import React from 'react';
import { Link } from 'react-router-dom';
import { Mail, Phone, MapPin, Facebook, Twitter, Linkedin, Instagram } from 'lucide-react';

const Footer = () => {
  const quickLinks = [
    { path: '/', label: 'Home' },
    { path: '/products', label: 'Products' },
    { path: '/manufacturers', label: 'Manufacturers' },
    { path: '/about', label: 'About Us' },
    { path: '/contact', label: 'Contact' }
  ];

  const productCategories = [
    'Semiconductors (ICs)',
    'Discrete Components',
    'Passive Components',
    'Active Components',
    'Electromechanical Components'
  ];

  return (
    <footer className="footer">
      <div className="container mx-auto px-6 py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {/* Company Info */}
          <div>
            <div className="footer-logo mb-4">
              <img 
                src="https://customer-assets.emergentagent.com/job_semiconductor-hub/artifacts/k89okgpd_6105172518529338560%20%281%29.jpg" 
                alt="Shree Techno Products" 
                className="footer-logo-image"
              />
            </div>
            <p className="footer-description">
              Your trusted global partner for genuine electronic components. Specializing in semiconductors and ICs.
            </p>
            <div className="social-links">
              <a href="#" className="social-icon" aria-label="Facebook">
                <Facebook className="h-5 w-5" />
              </a>
              <a href="#" className="social-icon" aria-label="Twitter">
                <Twitter className="h-5 w-5" />
              </a>
              <a href="#" className="social-icon" aria-label="LinkedIn">
                <Linkedin className="h-5 w-5" />
              </a>
              <a href="#" className="social-icon" aria-label="Instagram">
                <Instagram className="h-5 w-5" />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="footer-heading">Quick Links</h3>
            <ul className="footer-links">
              {quickLinks.map((link) => (
                <li key={link.path}>
                  <Link to={link.path} className="footer-link">
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Products */}
          <div>
            <h3 className="footer-heading">Products</h3>
            <ul className="footer-links">
              {productCategories.map((category) => (
                <li key={category}>
                  <Link to="/products" className="footer-link">
                    {category}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h3 className="footer-heading">Contact Info</h3>
            <ul className="footer-contact">
              <li className="footer-contact-item">
                <Mail className="h-4 w-4 flex-shrink-0" />
                <a href="mailto:sales@stechnoproducts.in">
                  sales@stechnoproducts.in
                </a>
              </li>
              <li className="footer-contact-item">
                <Phone className="h-4 w-4 flex-shrink-0" />
                <a href="tel:+919535217376">
                  +91 95352 17376
                </a>
              </li>
              <li className="footer-contact-item">
                <MapPin className="h-4 w-4 flex-shrink-0" />
                <span>
                  No. 53/2, 4th cross, Kaveripura, Kamakshipalya, Bengaluru, Karnataka - 560079
                </span>
              </li>
            </ul>
          </div>
        </div>

        <div className="footer-bottom">
          <div className="footer-divider"></div>
          <div className="footer-copyright">
            <p>&copy; {new Date().getFullYear()} Shree Techno Products. All rights reserved.</p>
            <p className="text-sm">GSTIN: 29JDFPS9009J1ZR</p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
